import { Input } from "@/components/ui/input";
import { formatUSPhone } from "@/lib/phone";

export { formatUSPhone };

export function PhoneInput({ value, onChange, ...props }) {
  return <Input type="tel" inputMode="tel" autoComplete="tel" placeholder="(555) 555-1234" maxLength={14} {...props} value={formatUSPhone(value)} onChange={(e) => onChange(formatUSPhone(e.target.value))} />;
}
